import React from "react";
import img from "../../assets/not_found_img.svg";
import "./not_found.scss";
const NotFound = () => {
  return (
    <div className="not_found_main">
      <div className="not_found_container">
        <img src={img} alt="Not Found Image" />
        <a href="/">
          <button>Back to Home</button>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
